module.exports = __webpack_public_path__ + "static/media/utilita4.156cc06f.png";